module.exports = __webpack_public_path__ + "img/smzq2.16572d88.png";